var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6H3M4.5 12H3M4.5 9H2.25M5.25 3.38666C6.32257 2.6687 7.61239 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C7.61239 15.75 6.32257 15.3313 5.25 14.6133M11.25 7.12493C10.875 7.03192 10.2638 7.0285 9.75 7.03192M9.75 7.03192C9.57818 7.03306 9.68206 7.02576 9.45 7.03192C8.84443 7.05081 8.25124 7.30249 8.25 8.01556C8.24869 8.77518 9 8.99993 9.75 8.99993C10.5 8.99993 11.25 9.17333 11.25 9.9843C11.25 10.5938 10.6444 10.8608 9.88957 10.9492C9.28957 10.9492 9 10.9687 8.25 10.8749M9.75 7.03192L9.75 6M9.75 11.25V12",
    stroke: "#152B35",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.3b3fc4f20035d7d86cb82a32240c62a4.svg";
export { ForwardRef as ReactComponent };